import { bingTrackEvent } from './useBingTrackEvent'

export type EventTrackingName =
  | 'sales_training_program__pageview'
  | 'sales_training__pageview'
  | 'sales_analytics__pageview'
  | 'product_specific__pageview'
  | 'product_overview__pageview'
  | 'job_specific__pageview'
  | 'sales_training_programs__click'
  | 'navbar_link_category__click'
  | 'navbar_link_item__click'
  | 'related_link_sales_enablement__click'
  | 'contact_form__submitted'
  | 'contact_form_multistep__submitted'
  | 'download_resource_form__submitted'
  | 'download_resource_form_email_only__submitted'
  | 'adblocker-detected'
  | 'form__posted'

export const track = (eventName: EventTrackingName, data: any) => {
  if (eventName === undefined) return
  bingTrackEvent(eventName, data)
  window?.gtag && window.gtag('event', eventName, data)
  window?.posthog && window.posthog?.capture(eventName, data)
}

export const trackFormSubmission = (formId, values: any) => {
  const trackingMap = new Map()
  trackingMap.set('contactUsForm', 'contact_form__submitted')
  trackingMap.set('multiStepContactForm', 'contact_form_multistep__submitted')
  trackingMap.set('downloadForm', 'download_resource_form__submitted')
  trackingMap.set('downloadFormEmailOnly', 'download_resource_form_email_only__submitted')
  try {
    track(trackingMap.get(formId), {
      url: window.location.href,
      ...values,
    })
  } catch (error) {
    console.error('tracking error', { error, formId, values })
  }
}
